import React, { createContext, useContext, useState, useCallback } from "react";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("rmb_lang") || "pt");

  const toggle = useCallback(() => {
    setLang((l) => {
      const next = l === "pt" ? "en" : "pt";
      localStorage.setItem("rmb_lang", next);
      return next;
    });
  }, []);

  const t = useCallback((pt, en) => (lang === "pt" ? pt : en), [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);

export const BLOG_INFO = {
  suica: { pt: "Blog Suíça", en: "Swiss Life", color: "#E63946", tw: "suica" },
  desenvolvimento: { pt: "Desenvolvimento", en: "Development", color: "#3B82F6", tw: "dev" },
  automacao: { pt: "Automação", en: "Automation", color: "#F59E0B", tw: "automacao" },
};
